import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import {
  SectionContainer,
  SectionTitle,
  SectionDetails,
  Separator,
} from '../../shared/sectionable/styles';
import Profile from './enquiry-components/profile';
import Form from './enquiry-components/form';
import Success from '../../shared/enquiry/success';
import EnquiryContext from '../../shared/enquiry/context';
import { scrollIfHashMatch } from '../../shared/navigation/utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: -64px;
  width: 100%;
`;

const SSeparator = styled(Separator)`
  ${props => props.theme.isMobile && `
    display: none;
  `};
`;

const SSectionContainer = styled(SectionContainer)`
  margin-top: 48px;
`;

const SSectionDetails = styled(SectionDetails)`
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
`;

const sectionName = 'enquiry';
export default function Enquiry({ profile, investorTypes }) {
  const { state: { showEnquiryForm, contactSent } } = React.useContext(EnquiryContext);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  return (
    <Container>
      <SSeparator />
      <SSectionContainer name={sectionName}>
        <SectionTitle id="contact">Enquiries</SectionTitle>
        <SSectionDetails>
          <Profile profile={profile} />
          {showEnquiryForm && !contactSent
          && <Form profile={profile} investorTypes={investorTypes} />}
          {contactSent && <Success organization={profile.organization} border />}
        </SSectionDetails>
      </SSectionContainer>
    </Container>
  );
}

Enquiry.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    slug: PropTypes.string,
    profilePictureUrl: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    activePartnership: PropTypes.shape({
      id: PropTypes.number,
    }),
  }).isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
};
